var indentation_default = {
  "indentZero": "-mwdm",
  "indentOne": "_7a7cy",
  "indentTwo": "nMnXe",
  "indentThree": "aaxoV",
  "indentFour": "y3YXX",
  "indentFive": "ZZRMd",
  "indentSix": "tyzKe"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
